import { render, staticRenderFns } from "./score.vue?vue&type=template&id=6d4c8ddd&scoped=true"
import script from "./score.vue?vue&type=script&lang=js"
export * from "./score.vue?vue&type=script&lang=js"
import style0 from "./score.vue?vue&type=style&index=0&id=6d4c8ddd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4c8ddd",
  null
  
)

export default component.exports